"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNativeAppWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Modal_1 = require("../../com/widget/Modal/Modal");
var appStyleClasses_1 = require("../../styles/appStyleClasses");
var emotion_1 = require("emotion");
var react_redux_1 = require("react-redux");
var appStylesBase_1 = require("../../styles/appStylesBase");
var envConfigBase_1 = require("../../envConfig/envConfigBase");
var UpdateNativeAppWatcher = function (_a) {
    var isIosNative = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ((_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.platformType) === 'IosNative';
    });
    var isAndroidNative = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ((_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.platformType) === 'AndroidNative';
    });
    var nativeVersion = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.nativeVersion;
    });
    var needToUpdate = (isAndroidNative || isIosNative) &&
        !!nativeVersion &&
        nativeVersion < 3; /* need !!nativeVersion to handle sign out reload */
    return (react_1.default.createElement(Modal_1.Modal, { showCloseButton: false, visible: needToUpdate },
        react_1.default.createElement("div", { className: (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          text-align: center;\n        "], ["\n          text-align: center;\n        "]))) },
            react_1.default.createElement("p", { className: (0, emotion_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n            margin-bottom: ", ";\n          "], ["\n            margin-bottom: ", ";\n          "])), (0, appStylesBase_1.appStylesBase)().spacing.medium) }, "You need the latest update to continue."),
            react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: isIosNative
                    ? (0, envConfigBase_1.envConfigBase)().appStoreUrl
                    : (0, envConfigBase_1.envConfigBase)().googlePlayUrl, className: appStyleClasses_1.appStyleClasses.actionButtonStyles() }, "ok"))));
};
exports.UpdateNativeAppWatcher = UpdateNativeAppWatcher;
var templateObject_1, templateObject_2;
